export enum ContentCreatorTypes {
  FreeDesign = "Free design",
  Templates = "Templates"
}